import PropTypes from 'prop-types';
import * as React from 'react';

import FilterNodeLabel from './FilterNodeLabel';
import styles from './FilterNodeLabelClickable.less';

class FilterNodeLabelClickable extends React.PureComponent {
  render() {
    const {label, onClick} = this.props;
    return (
      <button
        type={'button'}
        className={styles.dlFilterNodeLabelClickable}
        onClick={onClick}
      >
        <FilterNodeLabel label={label} />
      </button>
    );
  }
}

FilterNodeLabelClickable.displayName = 'FilterNodeLabelClickable';

FilterNodeLabelClickable.propTypes = {
  label: PropTypes.string,
  onClick: PropTypes.func.isRequired,
};

FilterNodeLabelClickable.defaultProps = {
  label: '',
};

export default FilterNodeLabelClickable;
